import React, { useEffect } from "react";
import { Table } from "antd";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import EmployeeScheduleTemplateForm from "./EmployeeScheduleTemplateForm";
import { useDispatch, useSelector } from "react-redux";
import { doEmployeeScheduleTemplateDelete, doEmployeeScheduleTemplateReset, getEmployeeScheduleTemplateList } from "../../../../redux/employeescheduletemplate/employeeScheduleTemplateState";
import Crudoption from "components/dropdown/crudoption";

const EmployeeScheduleTemplateTable = ({  }) => {

  const dispatch = useDispatch();
  const recordList = useSelector(  (state) => state.employeeScheduleTemplate.employeeScheduleTemplateList?.items);
  const pagination = useSelector((state) => state.employeeScheduleTemplate.employeeScheduleTemplateList);

  const columns = [
    {
      title: "Schedule Template Title",
      dataIndex: "est_title",
      key: "est_title",
      width: "88%",
    },
    {
	  title: (
		<div className="flex justify-center">
			<PopupButton
				id="add_employee_schedule_template"
				title="Add Schedule Template"
				label="Add"
				btnClass="btn-small"
				action="add"
			>
				<EmployeeScheduleTemplateForm
					recordId={0}
					mode="edit"
				/>
			</PopupButton>
		</div>
	  ),
	  dataIndex: "est_id",
	  key: "est_id",
	  width: "12%",
	  render: (_, record) => (
		<Crudoption
			baseRoute="/console/employee-schedule-templates"
			recordId={record?.est_id}
			deleteHandler={() =>
				dispatch(doEmployeeScheduleTemplateDelete(record?.est_id))
			}
			title="Edit Schedule"
			editMode="modal"
			editHandler={(recordId, doRecordReset) => (
				<EmployeeScheduleTemplateForm 
					recordId={recordId} 
					mode="edit" 
					onCancel={doRecordReset} 
				/>
			)}
		/>
	  ),
	},
  ];
	
  useEffect(() => {
	dispatch(
		getEmployeeScheduleTemplateList({
		  page: pagination.current_page || 1,
		  paginate: pagination.per_page || 10,
		})
	);
  }, [ dispatch, pagination.current_page, pagination.per_page, ]);

  return (
    <Card extra="w-full h-full p-4">
      <div className="h-full overflow-x-auto xl:overflow-x-hidden">
        <Table
          dataSource={recordList}
          columns={columns}
          rowKey={(record) => record.est_id}
          scroll={{ x: "max-content" }}
          pagination={{
            ...pagination,
            showTotal: (total, range) =>
              `${range[0]} - ${range[1]} of ${total} records`,
          }}
        />
      </div>
    </Card>
  );
};

export default EmployeeScheduleTemplateTable;